/* eslint-disable @typescript-eslint/no-unused-vars */
import { createContext } from 'react';

import {
  BilledEntry,
  UnbilledTimeEntry,
} from '@totem/components/ticketing/ticketing';
import { BillingInput } from '@totem/components/ticketing/types';

interface BillingContext {
  loading: boolean;
  unbilledData: UnbilledTimeEntry[];
  billedData: BilledEntry[];
  action: string;
  actionExtras: string;
  onAction: (newAction: string, extras: string) => void;
  selectedOrganizationId: string;
  selectedUnbilled: UnbilledTimeEntry[];
  selectUnbilled: (item: UnbilledTimeEntry) => void;
  deselectUnbilled: (item: UnbilledTimeEntry) => void;
  selectAllUnbilled: () => void;
  clearSelectedUnbilled: () => void;
  totalBilled: number;
  totalUnbilled: number;
  input: BillingInput;
  setInput: (newInput: Partial<BillingInput>) => void;
}

export default createContext<BillingContext>({
  loading: false,
  unbilledData: [],
  billedData: [],
  action: '',
  actionExtras: '',
  onAction: () => {},
  selectedOrganizationId: '',
  selectedUnbilled: [],
  selectUnbilled: (item: UnbilledTimeEntry) => {},
  deselectUnbilled: (item: UnbilledTimeEntry) => {},
  selectAllUnbilled: () => {},
  clearSelectedUnbilled: () => {},
  totalBilled: 0,
  totalUnbilled: 0,
  input: {
    startDate: null,
    endDate: null,
  },
  setInput: () => {},
});
